export default __webpack_public_path__ + "static/hopfen-318ee2fb963c56893b2de38896af547e.png";